/**
 * 4-digit PIN keypad with filled circles.
 */

export const PIN_LENGTH = 4

export interface PinInputProps {
  value: string
  onChange: (next: string) => void
  disabled?: boolean
}

export default function PinInput({ value, onChange, disabled }: PinInputProps) {
  const append = (d: string) => {
    if (disabled) return
    if (value.length >= PIN_LENGTH) return
    onChange(value + d)
  }
  const back = () => {
    if (disabled) return
    onChange(value.slice(0, -1))
  }

  return (
    <div className="flex flex-col items-center gap-8 w-full max-w-xs mx-auto">
      <div className="flex gap-3 justify-center" aria-hidden>
        {Array.from({ length: PIN_LENGTH }).map((_, i) => (
          <div
            key={i}
            className={`w-3 h-3 rounded-full border-2 transition-colors ${
              i < value.length ? 'bg-brand border-brand' : 'border-gray-600 bg-transparent'
            }`}
          />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-3 w-full">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', '⌫'].map((key, idx) => (
          <button
            key={`${key}-${idx}`}
            type="button"
            disabled={disabled || key === ''}
            onClick={() => {
              if (key === '⌫') back()
              else if (key) append(key)
            }}
            className={`h-14 rounded-xl text-xl font-medium transition-colors ${
              key === ''
                ? 'invisible pointer-events-none'
                : 'bg-surface-2 text-white active:bg-surface-3 border border-surface-3 disabled:opacity-40'
            }`}
          >
            {key === '⌫' ? '⌫' : key}
          </button>
        ))}
      </div>
    </div>
  )
}
